import { combineReducers } from 'redux';
import { SET_INSTANT_EXPERIENCES, SET_INSTANT_EXPERIENCES_OWNER } from './constants';

const instantExperiences = (state = false, { type, payload }) => {
  if (type === SET_INSTANT_EXPERIENCES) return Boolean(payload);
  return state;
};

const instantExperiencesOwner = (state = null, { type, payload = null }) => {
  if (type === SET_INSTANT_EXPERIENCES_OWNER) return payload;
  return state;
};

export default combineReducers({
  enabled: instantExperiences,
  owner: instantExperiencesOwner,
});



// WEBPACK FOOTER //
// ./src/app/instantExperiences/reducer.js